// extracted by mini-css-extract-plugin
export default {"fields":"E75Sya","time":"xmfVTG","mobile":"hvlfle"};